import { render, staticRenderFns } from "./NavViewMessageCenter.vue?vue&type=template&id=424a213f&scoped=true&"
import script from "./NavViewMessageCenter.vue?vue&type=script&lang=js&"
export * from "./NavViewMessageCenter.vue?vue&type=script&lang=js&"
import style0 from "./NavViewMessageCenter.vue?vue&type=style&index=0&id=424a213f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424a213f",
  null
  
)

export default component.exports